define.alias("shared/helpers/format-currency", "media/helpers/format-currency");